import { NbDialogConfig } from '@nebular/theme';

export type TDialogData = {
  config?: Partial<NbDialogConfig>;
  component: Promise<any>;
  successOnly?: boolean;
  isObservable?: boolean;
};

export enum EDialogAnswer {
  Confirm = 'confirm',
  Cancel = 'cancel',
}

export type TDialogAnswerPayload<T = unknown> =
  | {
      type: EDialogAnswer;
      payload?: T;
    }
  | undefined;
